import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AsyncPipe } from '@angular/common';
import { TuiButtonModule } from '@taiga-ui/experimental';
import { AuroraTextComponent } from '@shared/components/aurora-text/aurora-text.component';
import { RouteNames } from '../../route-names';

@Component({
  selector: 'app-home',
  imports: [RouterLink, AsyncPipe, TuiButtonModule, AuroraTextComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HomeComponent {
  protected readonly RouterLink = RouterLink;
  protected readonly RouteNames = RouteNames;
}
